module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "mu.c5f449ce.png" + "?" + Date.now();